import { createBrowserRouter } from 'react-router-dom';
import { Login } from '../pages/Login';
import { Main } from '../pages/Main';
import { UploadFilePage } from '../pages/UploadFilePage';
import { Withdrawal } from '../pages/Withdrawal';
import { Edit } from '../pages/Edit';
import { Home } from '../pages/Home';
import Settings from '../pages/Settings';
import Developers from '../pages/Developers';
import { PasswordForgot } from '../pages/PasswordForgot';
import { PasswordChange } from '../pages/PasswordChange';
import { Roles } from '../pages/Roles';
import { Profile } from '../pages/Profile';
import { Compliance } from '../pages/Compliance.jsx';
import { ComplianceDetails } from '../pages/ComplianceDetails';
import { TransactionDetailsPages } from '../pages/TransactionDetails';
import { PasswordForgotOtp } from '../pages/PasswordForgotOTP';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />
  },
  {
    path: "/forgot-password",
    element: <PasswordForgot />
  },
  {
    path: "/forgot-password-validate",
    element: <PasswordForgotOtp />
  },
  {
    path: "/change-password",
    element: <PasswordChange />
  },
  {
    path: "/dashboard",
    element: <Home />
  },
  {
    path: "/completed-transactions",
    element: <Home />
  },
  {
    path: "/pending-transactions",
    element: <Home />
  },
  {
    path: "/withdrawal",
    element: <Withdrawal />
  },
  {
    path: "/withdrawal/details/:userId",
    element: <TransactionDetailsPages />
  },
  {
    path: "/setting",
    element: <Settings onSearchGen={''} />
  },
  {
    path: "/developers",
    element: <Developers onSearchGen={''} />
  },
  {
    path: "/compliance",
    element: <Compliance onSearchGen={''} />
  },
  {
    path: "/compliance/details/:id",
    element: <ComplianceDetails onSearchGen={''} />
  },
  {
    path: "/monthly-reports",
    element: <Withdrawal />
  },
  {
    path: "/upload",
    element: <UploadFilePage />
  },
  {
    path: "/download",
    element: <Main />
  },
  {
    path: "/edit/:id",
    element: <Edit />
  },
  {
    path: "/roles",
    element: <Roles onSearchGen={''} />
  },
  {
    path: "/profile",
    element: <Profile onSearchGen={''} />
  }
])

export default router